import { CalculatorLink } from '@/components/blog/CalculatorLink'
import { BlogLink } from '@/components/blog/BlogLink'

export default function Article() {
  return (
    <>
      <p>
        Wybór okresu kredytowania to jedna z najważniejszych decyzji przy zaciąganiu kredytu
        hipotecznego — i ma większy wpływ na całkowity koszt niż większość ludzi sądzi. Ten sam
        kredyt 400 000 zł na 15 zamiast 30 lat oznacza ratę wyższą o ok. 960 zł miesięcznie,
        ale niższe odsetki o ponad <strong>280 000 zł</strong>. Sprawdź, jak wybrać okres
        pasujący do Twojego budżetu i celów.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Co to jest okres kredytowania?</h2>
      <p>
        Okres kredytowania to liczba lat, na które zaciągasz kredyt — czyli czas, w którym
        spłacasz ratę co miesiąc. W Polsce standardem są kredyty hipoteczne na 25-30 lat,
        ale banki oferują w zasadzie od 5 do 35 lat. Im dłuższy okres, tym niższa rata, ale
        wyższy łączny koszt odsetek.
      </p>
      <p className="mt-3">
        Maksymalny okres regulują dwa czynniki:
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Rekomendacja S Komisji Nadzoru Finansowego</strong> — formalny limit to 35 lat</li>
        <li><strong>Wiek kredytobiorcy</strong> — większość banków wymaga, aby ostatnia rata została spłacona zanim kredytobiorca skończy 70-75 lat</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Porównanie 15, 25 i 30 lat</h2>
      <p>
        Zobaczmy konkretne liczby. Założenia: kredyt 400 000 zł, oprocentowanie 6,5%
        (typowe w 2026 roku), raty równe.
      </p>

      <div className="bg-muted/50 rounded-xl p-4 mt-3">
        <p className="font-semibold mb-2">15 lat — krótki okres</p>
        <ul className="list-disc pl-6 space-y-1 text-sm">
          <li>Rata miesięczna: <strong>~3 490 zł</strong></li>
          <li>Łączne odsetki: <strong>~227 000 zł</strong></li>
          <li>Łącznie spłacisz: <strong>~627 000 zł</strong></li>
        </ul>
      </div>

      <div className="bg-muted/50 rounded-xl p-4 mt-3">
        <p className="font-semibold mb-2">25 lat — standardowy</p>
        <ul className="list-disc pl-6 space-y-1 text-sm">
          <li>Rata miesięczna: <strong>~2 700 zł</strong></li>
          <li>Łączne odsetki: <strong>~410 000 zł</strong></li>
          <li>Łącznie spłacisz: <strong>~810 000 zł</strong></li>
        </ul>
      </div>

      <div className="bg-muted/50 rounded-xl p-4 mt-3">
        <p className="font-semibold mb-2">30 lat — długi okres</p>
        <ul className="list-disc pl-6 space-y-1 text-sm">
          <li>Rata miesięczna: <strong>~2 530 zł</strong></li>
          <li>Łączne odsetki: <strong>~510 000 zł</strong></li>
          <li>Łącznie spłacisz: <strong>~910 000 zł</strong></li>
        </ul>
      </div>

      <p className="mt-3">
        Wnioski są jasne. Skrócenie z 30 do 15 lat oznacza ratę wyższą o ok. 960 zł miesięcznie,
        ale aż <strong>283 000 zł</strong> oszczędności na odsetkach. Z drugiej strony — dłuższy
        okres daje niższą ratę i większy oddech w domowym budżecie.
      </p>

      <div className="mt-4">
        <CalculatorLink propertyPrice={500000} downPaymentPercent={20} loanYears={15} wiborRate={4.5} bankMargin={2.0}>
          Sprawdź ratę przy 15 latach spłaty
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Jak okres wpływa na zdolność kredytową?</h2>
      <p>
        Im dłuższy okres, tym niższa rata — a niższa rata oznacza wyższą{' '}
        <BlogLink slug="jak-obliczyc-zdolnosc-kredytowa">zdolność kredytową</BlogLink>. Bank
        patrzy na to, jaką część dochodu zajmie rata. Przy zarobkach 7 000 zł netto i limicie
        35% dochodu maksymalna rata to 2 450 zł.
      </p>

      <div className="bg-muted/50 rounded-xl p-4 mt-3">
        <p className="font-semibold mb-2">Maksymalny kredyt przy racie 2 450 zł i oprocentowaniu 6,5%:</p>
        <ul className="list-disc pl-6 space-y-1 text-sm">
          <li>15 lat — ok. <strong>281 000 zł</strong></li>
          <li>25 lat — ok. <strong>363 000 zł</strong></li>
          <li>30 lat — ok. <strong>388 000 zł</strong></li>
        </ul>
      </div>

      <p className="mt-3">
        Wydłużenie okresu z 25 do 30 lat zwiększa zdolność tylko o ok. 25 000 zł — niewiele,
        bo każdy kolejny rok spłaty dodaje coraz mniej kapitału do dostępnej kwoty.{' '}
        <strong>Ważna uwaga:</strong> zgodnie z Rekomendacją S KNF bank, wyliczając zdolność
        kredytową, zakłada okres maksymalnie 25 lat — niezależnie od tego, na ile lat formalnie
        weźmiesz kredyt. To zabezpieczenie przed sztucznym zawyżaniem zdolności przez wybór
        bardzo długich okresów.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Kiedy wybrać krótszy okres?</h2>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Masz wysoką zdolność kredytową</strong> — komfortowo udźwigniesz wyższą ratę bez napinania budżetu</li>
        <li><strong>Chcesz minimalizować całkowity koszt</strong> — krótki okres daje najmniej odsetek w sumie</li>
        <li><strong>Jesteś bliżej emerytury</strong> — chcesz spłacić kredyt zanim dochody spadną</li>
        <li><strong>Wolisz wcześniej "uwolnić się" od raty</strong> — skończyć spłatę i przeznaczać budżet na inne cele</li>
        <li><strong>Spodziewasz się stabilnych dochodów</strong> — masz pewność, że utrzymasz wysoką ratę przez cały okres</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Kiedy wybrać dłuższy okres?</h2>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong><BlogLink slug="ile-zarabiac-na-kredyt-hipoteczny">Zdolność kredytowa</BlogLink> jest na granicy</strong> — niższa rata to większa szansa na akceptację wniosku</li>
        <li><strong>Chcesz oddech w budżecie</strong> — różnica 770 zł/mies. między 15 a 25 latami to istotna pozycja w finansach domowych</li>
        <li><strong>Planujesz aktywnie <BlogLink slug="nadplata-kredytu-hipotecznego">nadpłacać kredyt</BlogLink></strong> — możesz kontrolować tempo spłaty bez sztywnego zobowiązania</li>
        <li><strong>Jesteś młody</strong> — 30-letni kredyt w wieku 30 lat skończy się przed emeryturą</li>
        <li><strong>Spodziewasz się wzrostu dochodów</strong> — startujesz z niską ratą, z czasem zyskasz przestrzeń na nadpłaty</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Strategia hybrydowa: długi okres + nadpłaty</h2>
      <p>
        To rozwiązanie, które wybiera coraz więcej kredytobiorców. Bierzesz formalnie 30-letni
        kredyt z niską obowiązkową ratą, a sam dobrowolnie nadpłacasz, gdy masz wolne środki.
      </p>
      <p className="mt-3">
        <strong>Plusy:</strong>
      </p>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Elastyczność</strong> — w trudniejszym miesiącu płacisz tylko obowiązkową ratę 2 530 zł</li>
        <li><strong>Bezpieczeństwo</strong> — niska "obowiązkowa" rata to mniejsze ryzyko utraty mieszkania przy spadku dochodów</li>
        <li><strong>Oszczędność na odsetkach</strong> — gdy masz wolne środki, nadpłata skraca okres i obniża sumaryczne odsetki</li>
      </ul>
      <p className="mt-3">
        <strong>Minus:</strong> jeśli nie nadpłacasz konsekwentnie, zapłacisz znacznie więcej
        odsetek niż przy krótszym kredycie od początku. Strategia działa tylko wtedy, gdy masz
        dyscyplinę finansową.
      </p>

      <div className="mt-4">
        <CalculatorLink propertyPrice={500000} downPaymentPercent={20} loanYears={30} wiborRate={4.5} bankMargin={2.0} monthlyOverpayment={1000} section="overpayment">
          Symuluj 30-letni kredyt z nadpłatą 1 000 zł
        </CalculatorLink>
      </div>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Limity okresu kredytowania</h2>
      <ul className="list-disc pl-6 space-y-2 mt-3">
        <li><strong>Maksymalny okres formalny:</strong> 35 lat (Rekomendacja S KNF)</li>
        <li><strong>Limit wieku:</strong> większość banków wymaga, aby ostatnia rata została spłacona przed 70.-75. rokiem życia. Przy zaciąganiu w wieku 50 lat realny okres to 20-25 lat</li>
        <li><strong>Okres do liczenia zdolności:</strong> bank zakłada maksymalnie 25 lat, niezależnie od formalnej długości kredytu</li>
        <li><strong>Minimalny okres:</strong> formalnie 5 lat, w praktyce sensowne minimum to 10-15 lat — krócej oznaczałoby bardzo wysoką ratę</li>
      </ul>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Co wybierają Polacy?</h2>
      <p>
        Według danych Związku Banków Polskich najczęściej wybieraną długością kredytu hipotecznego
        w Polsce jest <strong>25-30 lat</strong>. Krótsze kredyty (do 15 lat) stanowią nieduży
        odsetek nowych zobowiązań — głównie biorą je osoby z wysokim wkładem własnym lub bliżej
        emerytury. Trend ostatnich lat to wydłużanie okresu kredytowania, co wynika z rosnących
        cen nieruchomości względem dochodów.
      </p>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Decyzja w 4 krokach</h2>
      <ol className="list-decimal pl-6 space-y-2 mt-3">
        <li><strong>Policz maksymalną komfortową ratę</strong> — nie więcej niż 30-35% dochodu netto</li>
        <li><strong>Wpisz tę ratę w kalkulatorze</strong> i sprawdź, jaki okres odpowiada potrzebnej kwocie kredytu</li>
        <li><strong>Sprawdź, czy stać Cię na krótszy okres</strong> — jeśli budżet wytrzyma 25 zamiast 30 lat, zaoszczędzisz ok. 100 000 zł na odsetkach</li>
        <li><strong>Rozważ strategię hybrydową</strong> — formalnie 30 lat plus systematyczne nadpłaty dają elastyczność i niski koszt</li>
      </ol>

      <h2 className="text-2xl font-bold text-foreground mt-8 mb-4">Podsumowanie</h2>
      <p>
        Okres kredytowania to gra między wysokością miesięcznej raty a całkowitym kosztem
        kredytu. Krótszy okres oznacza niższe odsetki i szybszą wolność finansową, ale wyższą
        ratę. Dłuższy okres daje oddech w budżecie i wyższą zdolność, ale więcej zapłacisz
        odsetek. Najczęstszy wybór w Polsce — 25-30 lat — to rozsądny kompromis. Najbardziej
        elastyczna strategia: weź kredyt na 30 lat i nadpłacaj, gdy masz wolne środki.
      </p>

      <div className="mt-4">
        <CalculatorLink section="affordability">
          Porównaj okresy w kalkulatorze RatyGo
        </CalculatorLink>
      </div>
    </>
  )
}
